import { useState, useEffect, useCallback } from "react";
import { API_CONST } from "../const";

const useLocationOptions = (initialCountry = null) => {
  const [countries, setCountries] = useState([]);
  const [cities, setCities] = useState([]);
  const [loadingCountries, setLoadingCountries] = useState(false);
  const [loadingCities, setLoadingCities] = useState(false);

  useEffect(() => {
    const fetchCountries = async () => {
      setLoadingCountries(true);
      try {
        const token = localStorage.getItem("authToken");
        const response = await fetch(API_CONST.LOCATIONS_COUNTRIES, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (response.ok) {
          const data = await response.json();
          setCountries(data.countries || []);
        }
      } catch {
      } finally {
        setLoadingCountries(false);
      }
    };
    fetchCountries();
  }, []);

  const fetchCities = useCallback(async (country) => {
    if (!country) {
      setCities([]);
      return;
    }
    setLoadingCities(true);
    try {
      const token = localStorage.getItem("authToken");
      const url = country
        ? `${API_CONST.LOCATIONS_CITIES}?country=${encodeURIComponent(country)}`
        : API_CONST.LOCATIONS_CITIES;
      const response = await fetch(url, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.ok) {
        const data = await response.json();
        setCities(data.cities || []);
      }
    } catch {
    } finally {
      setLoadingCities(false);
    }
  }, []);

  useEffect(() => {
    if (initialCountry) {
      fetchCities(initialCountry);
    }
  }, [initialCountry, fetchCities]);

  return { countries, cities, fetchCities, loadingCountries, loadingCities };
};

export default useLocationOptions;
